import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './UserPreferencesModal.css';
import Aux from '../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../UI/Backdrop/Backdrop';
import personImg from '../../assets/images/person-icon.png';
import deleteImg from '../../assets/images/delete-icon.png';
import closeImg from '../../assets/images/close-icon.png';
import closeWhiteImg from '../../assets/images/close-white-icon.png';
import arrowImg from '../../assets/images/arrow-right-icon.png';
import phoneImg from '../../assets/images/phone-icon.png';
import plusImg from '../../assets/images/plus-icon.png';
import sideBySideImg from '../../assets/images/side-by-side-icon.png';
import stackedImg from '../../assets/images/stacked-icon.png';
import axios from '../../axios-trips';
import logError from '../../store/LogError';
import * as actionTypes from '../../store/actions';
import saveImg from '../../assets/images/save-icon.png';
import historyImg from '../../assets/images/history-icon.png';
import Icon from '../UI/Icon/Icon';
import Button from '../UI/Button/Button';
import ButtonIconConfirm from '../UI/ButtonIconConfirm/ButtonIconConfirm';
import ButtonIcon from '../UI/ButtonIcon/ButtonIcon';
import Input from '../UI/Input/Input';
import Spinner from '../UI/Spinner/Spinner';
import Modal from '../UI/Modal/Modal';

class UserPreferences extends Component {

  createInputConfig = (elementType,
                       elementConfig,
                       label,
                       value='',
                       validation={},
                       valid=true,
                       extraAction=null,
                       extraClass=null) => {
    return ({
      elementType: elementType,
      elementConfig: elementConfig,
      label: label,
      value: value,
      validation: validation,
      valid: valid,
      extraAction: extraAction,
      extraClass: extraClass,
      touched: false,
      errorMessage: null
    });
  }

  state = {
    localCard: null,
    loading: false,
    userPreferencesForm : {
      preferences: this.createInputConfig(
        'checklist',
        {
          options: [
            { displayValue: "Отсл_Начата", value: "Отсл_Начата", checked: false, extra: "(начата отгрузка со склада)" },
            { displayValue: "Отсл_Окончена", value: "Отсл_Окончена", checked: false, extra: "(завершена отгрузка со склада)" },
            { displayValue: "Отсл_Отправлена", value: "Отсл_Отправлена", checked: false, extra: "(машина вышла в рейс)" },
            { displayValue: "Отсл_Маршрут", value: "Отсл_Маршрут", checked: false, extra: "(ожидается, на выгрузке, выгружена)" }
          ]
        },
        'Предпочтения Пользователя (НЕ получать сообщения определенного типа, если флаг проставлен):',
        '',
        {},
        true)
    }
  }

  saveUserPreferences(ev) {
    ev.preventDefault();
    const parsedUserPreferences = [];
    this.state.userPreferencesForm.preferences.elementConfig.options.forEach(userPreference => {
      if (userPreference.checked) {
        parsedUserPreferences.push({ manager: null, preference: { userPreference: userPreference.displayValue } });
      }
    });

    axios({
      method: 'post',
      url: '/api/v1/manager-preference/manager?manager=' + this.props.manager,
      data: parsedUserPreferences,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      this.props.close();
    })
    .catch(error => {
      console.log(error.response);
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/manager-preference/manager'
        );
      }
    });
  }

  getManagerInfo(manager) {
    axios({
      method: 'get',
      url: '/api/v1/manager-preference/manager?manager=' + manager,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      const updatedUserForm = {...this.state.userPreferencesForm};
      for (let i = 0; i < updatedUserForm.preferences.elementConfig.options.length; i++) {
        updatedUserForm.preferences.elementConfig.options[i].checked = false;
      }

      for (let i = 0; i < response.data.length; i++) {
        if (response.data[i].preference.userPreference === "Отсл_Начата") {
           updatedUserForm.preferences.elementConfig.options[0].checked = true;
        } else if (response.data[i].preference.userPreference === "Отсл_Окончена") {
           updatedUserForm.preferences.elementConfig.options[1].checked = true;
        } else if (response.data[i].preference.userPreference === "Отсл_Отправлена") {
           updatedUserForm.preferences.elementConfig.options[2].checked = true;
        } else if (response.data[i].preference.userPreference === "Отсл_Маршрут") {
           updatedUserForm.preferences.elementConfig.options[3].checked = true;
        }
      }

      this.setState({ userPreferencesForm: updatedUserForm });
    })
    .catch(error => {
      console.log(error.response);
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/manager-preference/manager'
        );
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.manager && this.props.manager) {
      this.getManagerInfo(this.props.manager);
    }
  }

  inputChangedHandler = (event, elementId) => {
    const updatedOrderForm = {
      ...this.state.userPreferencesForm
    }
    const updatedFormElement = {
      ...updatedOrderForm[elementId]
    }

    updatedFormElement.value = event.target.value;
    updatedFormElement.touched = true;
    updatedOrderForm[elementId] = updatedFormElement;

    this.setState({ userPreferencesForm : updatedOrderForm, formIsValid: true });
  }

  render () {
    const userPreferencesForm = [];
    for (let key in this.state.userPreferencesForm) {
      userPreferencesForm.push({ id: key, config: this.state.userPreferencesForm[key] });
    }

    let loading = null;
    if (this.state.loading) {
      loading = (
        <Spinner />
      )
    }

    let headerClasses = [classes.Header];
    headerClasses.push(classes.HeaderWhite);

    let card = (
      <Aux>
        <div className={headerClasses.join(' ')}>

          <div className={classes.CarrierTitle}>
            <Icon iconClass={classes.CarIcon} iconSource={personImg} iconAlt='' className={classes.CardIcon} />
            Предпочтения Пользователя
          </div>

          <button className={classes.CloseButton} onClick={this.props.close}>
            <Icon iconClass={classes.CloseIcon} iconSource={closeImg} iconAlt='' />
          </button>
          <p style={{height: "100%"}}></p>
        </div>

        <div className={classes.Body} >
          { loading }

          <h3>{ this.props.manager }</h3>

          {userPreferencesForm.map(formElement => {
            return (
              <Input
                key={formElement.id}
                label={formElement.config.label}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                extraClass={formElement.config.extraClass}
                extraAction={formElement.config.extraAction}
                changed={(event) => this.inputChangedHandler(event, formElement.id)} />
              );
          })}

        </div>

        <div className={classes.Footer}>

          <div className={classes.FooterButtons}>
            </div>
        </div>
      </Aux>
    );

    let carrierClass = classes.CardModal;
    let extraStyle = this.props.noRestrictions ? { left: "50%", position: "absolute" } : {};
    return(
      <Aux>
        <Backdrop show={this.props.show && !this.props.noRestrictions} clicked={this.props.close} />
        <div
          className={carrierClass}
          style={{ transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
                  opacity: this.props.show ? '1' : '0',
                  ...extraStyle }}>
          {card}
          <ButtonIcon
            btnType='Success'
            clicked={(ev) => this.saveUserPreferences(ev)}
            iconClass={classes.ButtonIcon}
            iconSource={saveImg}
            small
            iconAlt=''>Сохранить</ButtonIcon>
          <ButtonIcon
            btnType='Danger'
            clicked={this.props.close}
            iconClass={classes.ButtonIcon}
            iconSource={closeWhiteImg}
            small
            iconAlt=''>ЗАКРЫТЬ</ButtonIcon>
        </div>
      </Aux>
    );
  }
};

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    notifications: state.notifications,
    codeToMessage: state.codeToMessage
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({ type: actionTypes.ADD_NOTIFICATION,
                                                                   notification: notification,
                                                                   notificationType: notificationType })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPreferences);



// WEBPACK FOOTER //
// ./src/components/UserPreferencesModal/UserPreferencesModal.js